import firebase from './init'
import store from './firestore'
import Vue from 'vue'

Vue.prototype.$firebase = firebase
Vue.prototype.$firestore = store

export default firebase
